import { render } from "./GameTop.vue?vue&type=template&id=bcc0189a"
import script from "./GameTop.vue?vue&type=script&lang=js"
export * from "./GameTop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__